export default {"src":"/_next/static/media/mindervalide-toilet.77e86ef8.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};